import { render, staticRenderFns } from "./MathScore.vue?vue&type=template&id=1603ae1e&scoped=true&"
import script from "./MathScore.vue?vue&type=script&lang=js&"
export * from "./MathScore.vue?vue&type=script&lang=js&"
import style0 from "./MathScore.vue?vue&type=style&index=0&id=1603ae1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603ae1e",
  null
  
)

export default component.exports